import { Button, Dropdown, LabelComponent, Stack, StandardCheckbox } from 'components';
import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { noteTypeData, setNoteType } from 'store/aiScribe/aiScribeSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import style from './idleScreen.module.scss';
import { useAiScribeContext } from '../../../context/useAiScribe';

type Props = {
  startRecording: ({ noteType }: { noteType: string }) => void;
  initializing: boolean;
};

const IdleScreen = ({ startRecording, initializing }: Props) => {
  const { error } = useAiScribeContext();
  const dispatch = useAppDispatch();
  const { noteType } = useAppSelector((s) => s.aiScribe);
  const [consent, setConsent] = useState<boolean>(false);

  return (
    <Stack
      mt="128px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyItems="center"
      justifyContent="center"
      width="100%"
      px="24px"
      boxSizing="border-box"
    >
      <Stack px="24px" width="100%">
        <LabelComponent text="Note Type" />
        <Dropdown
          disableAutoFocus
          smallDropdown
          withGradient
          label="Select"
          data={noteTypeData}
          onChange={(e) => {
            dispatch(setNoteType(e.target.value as string));
          }}
          name="noteType"
          id="noteType"
          value={noteType ?? ''}
        />
      </Stack>
      <Stack mt="72px" mb="20px">
        <StandardCheckbox
          label="This client is OK with being recorded"
          value={consent}
          onChange={(e) => setConsent(e.target.checked)}
        />
      </Stack>
      <Stack width="176px">
        <Button
          handleOnClick={() => startRecording({ noteType: noteType ?? '' })}
          text="Record"
          icon={<span className="material-icons">mic</span>}
          theme="primary"
          size="large"
          disabled={!consent || initializing}
        />
      </Stack>
      <AnimatePresence>
        {error && (
          <motion.div
            className={style.error}
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
          >
            <span className="material-icons">error_outline</span>
            <p>{error}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </Stack>
  );
};

export default IdleScreen;
